import { SearchStoreType } from '@/types/storeTypes/searchStoreType'
import { StateCreatorType } from '@/types/storeTypes/storeType'

export const searchStoreInitialData = {
  items: [],
  next: '',
  totalCount: 0,
}
const searchStore: StateCreatorType<SearchStoreType> = (set) => ({
  data: {
    suggestions: [],
    pages: searchStoreInitialData,
    events: searchStoreInitialData,
    searchValue: '',
  },
  loading: {
    suggestions: false,
    pages: false,
    events: false,
  },
  error: {
    suggestions: false,
    pages: false,
    events: false,
  },

  setSuggestions: (suggestions) =>
    set(
      (state) => void (state.search.data.suggestions = suggestions),
      false,
      'setSuggestions',
    ),
  setPages: (pages) =>
    set((state) => void (state.search.data.pages = pages), false, 'setPages'),
  setEvents: (events) =>
    set(
      (state) => void (state.search.data.events = events),
      false,
      'setEvents',
    ),
  setLoading: (key, isLoading = true) =>
    set(
      (state) => void (state.search.loading[key] = isLoading),
      false,
      'setLoading',
    ),
  setError: (key, isError = true) =>
    set((state) => void (state.search.error[key] = isError), false, 'setError'),
  setSearchValue: (value) =>
    set(
      (state) => void (state.search.data.searchValue = value),
      false,
      'setSearchValue',
    ),
})

export default searchStore
